import React from 'react'
import PropTypes from 'prop-types'
import AutomaticQuestions from 'components/ProspectDashboard/AutomaticQuestions'
import { Expansible } from 'components/Expansible'
import BuildProcesses from 'components/ExpandedInfo/BgcExpansible/BuildProcesses'
import { DisplayProcesses } from 'components/DueDiligence/Questions'

import styles from './styles'

function BuildProcessesReviewInfo(props) {
  const { reviewData } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Dados auxiliares para a análise</h2>
      <Expansible title="Respostas do formulário Due Diligence">
        <div className={classes.questionsList}>
          {reviewData?.related_form_answers?.map((answer) => {       
            return answer?.answer_object?.items?.length > 0 ? (
              <DisplayProcesses
                key={answer.uuid}
                questionData={answer.answer_object}
              />
            ) : null
          })}
        </div>
      </Expansible>
      {reviewData?.extra_questions && (
        <Expansible title="Respostas às questões automáticas relacionadas à pergunta">
          <AutomaticQuestions questions={reviewData?.extra_questions} />
        </Expansible>
      )}

      <Expansible title="Dados do Bureau relacionados ao assessor">
        <BuildProcesses processData={reviewData.process_data} />
      </Expansible>
    </div>
  )
}

BuildProcessesReviewInfo.propTypes = {
  reviewData: PropTypes.shape({
    created: PropTypes.string,
    updated: PropTypes.string,
    uuid: PropTypes.string,
    decisions: PropTypes.arrayOf(
      PropTypes.shape({
        created: PropTypes.string,
        updated: PropTypes.string,
        uuid: PropTypes.string,
        area_decision: PropTypes.string,
        reviewer_id: PropTypes.number,
        reviewer: PropTypes.shape({
          uuid: PropTypes.string,
          email: PropTypes.string,
          display_name: PropTypes.string,
        }),
        reviewer_comment: PropTypes.string,
        current_review_area: PropTypes.string,
      }),
    ),
    result: PropTypes.string,
    current_review_area: PropTypes.string,
    reason: PropTypes.string,
    related_form_answers: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        answer_object: PropTypes.object,
      }),
    ),

    extra_questions: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        text: PropTypes.string,
        occurrence: PropTypes.shape({
          reason: PropTypes.string,
          classification: PropTypes.string,
        }),
        answered: PropTypes.bool,
        subject: PropTypes.string,
      }),
    ),
    type: PropTypes.string,
    process_data: PropTypes.shape({
      uuid: PropTypes.string,
      created: PropTypes.string,
      updated: PropTypes.string,
      has_criminal_process: PropTypes.bool,
      has_non_criminal_process: PropTypes.bool,
      has_any_process: PropTypes.bool,
      has_process_from_regulatory_entity: PropTypes.bool,
      has_financial_penalty: PropTypes.bool,
      has_process_with_risk_keywords: PropTypes.bool,
      has_administrative_process: PropTypes.bool,
      has_judicial_process: PropTypes.bool,
      search_engine: PropTypes.string,
      processes: PropTypes.arrayOf(
        PropTypes.shape({
          uuid: PropTypes.string,
          court_description: PropTypes.string, 
          number: PropTypes.string, 
          has_number: PropTypes.bool,
          subject: PropTypes.string, 
          type: PropTypes.string, 
          is_certificate: PropTypes.bool, 
          contains_risk_keyword: PropTypes.bool, 
          is_financial_penalty: PropTypes.bool,
          is_moved_by_regulatory_entity: PropTypes.bool,
          data: PropTypes.object,
        }),
      ),
    }),
  }).isRequired,
}

export default BuildProcessesReviewInfo
